// export this package's api
import Upload from './Upload';

export default Upload;